module.exports = __webpack_public_path__ + "img/ic_link.e3c251ae.svg";